import { tv } from 'tailwind-variants';

export const mobileMenuButtonStyle = tv({
  base: 'flex w-full items-center justify-between px-4 py-2 text-left',
  variants: {
    currentPage: 'underline',
  },
});
